import { render, staticRenderFns } from "./active-proj.vue?vue&type=template&id=6553913a&scoped=true&"
import script from "./active-proj.vue?vue&type=script&lang=ts&"
export * from "./active-proj.vue?vue&type=script&lang=ts&"
import style0 from "./active-proj.vue?vue&type=style&index=0&id=6553913a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553913a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
